import { render, staticRenderFns } from "./acctSecurityDc.vue?vue&type=template&id=4c3d1428&scoped=true"
import script from "./acctSecurityDc.vue?vue&type=script&lang=js"
export * from "./acctSecurityDc.vue?vue&type=script&lang=js"
import style0 from "./acctSecurityDc.vue?vue&type=style&index=0&id=4c3d1428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d1428",
  null
  
)

export default component.exports